import React, { Component } from 'react'
import Client from '../Client'
//import BlackLoading from '../images/black-loader.gif'
//import marked from 'marked' //to make font bold and headings
import {Link} from 'react-router-dom';
import Categories from '../Components/Categories';

class MulchesSoilAmendments extends Component {
    constructor(props) {
        super(props)
        this.state = {
             mulchessoilpage:[]
        }
    }

    componentDidMount(){
        Client.getEntries({
            'content_type': 'mulchessoilamendments',
            'order': 'sys.createdAt'

        }).then((entries)=>{
            this.setState({mulchessoilpage: entries.items})
        })
    }

   
    render() {
        let MulchesSoilAmendmentsList = this.state.mulchessoilpage.map((val, i) => {
            return(
                <div className="col-lg-4 col-md-4 col-12" key={i}>
                    <div className="service-grid-item">
                    <div className="service-grid-item__image">
                        <div className="service-grid-item__image-wrapper">
                        <Link to={`${process.env.PUBLIC_URL}/mulches-soil-amendments-details/${val.fields.slug}`}>
                            <img src={val.fields.mulchessoilamendmentsImg.fields.file.url} className="img-fluid" alt="our plants" />
                        </Link>
                        </div>
                    </div>
                    <div className="service-grid-item__content">
                        <h1>
                        <Link to={`${process.env.PUBLIC_URL}/mulches-soil-amendments-details/${val.fields.slug}`}>{val.fields.mulchessoilamendmentsTitle}</Link>
                        </h1>
                        {/* <p className="subtitle">{val.fields.bookExcerpt}</p>
                        <Link to={`${process.env.PUBLIC_URL}/landscape-design-details/${val.fields.slug}`} className="see-more-link">SEE MORE</Link> */}
                    </div>
                    </div>
                </div>
            )
        });

        return (
            <div>
            <div><Categories/></div>
            <div className="container-fluid pt-2">
                <div className="row">
                    {MulchesSoilAmendmentsList}
                </div>           
            </div>
            </div>
        )
    }
}

export default MulchesSoilAmendments
